import { createSelector } from 'reselect';

const getCalendar = (state) => state.calendar || {};

export const selectFetching = createSelector(
  getCalendar,
  ({ fetching }) => !!fetching
);

export const selectGenerateFetching = createSelector(
  getCalendar,
  ({ generateFetching }) => generateFetching
);

export const selectSuccess = createSelector(
  getCalendar,
  ({ success }) => success
);

export const selectUserJobs = createSelector(
  getCalendar,
  ({ userJobs }) => userJobs
);

export const selectUserJobsInPeriod = createSelector(
  getCalendar,
  ({ userJobsInPeriod }) => userJobsInPeriod
);

export const selectCalendarEvents = createSelector(
  getCalendar,
  ({ calendarEvents }) => calendarEvents
);

export const selectUserJobsInDay = createSelector(
  getCalendar,
  ({ userJobsInDay }) => userJobsInDay
);

export const selectTotalWorkInPeriod = createSelector(
  getCalendar,
  ({ totalWorkInPeriod }) => totalWorkInPeriod
);

export const selectFaultyEvents = createSelector(
  getCalendar,
  ({ faultyEvents }) => faultyEvents
);

export const selectMultipleDeleteFetching = createSelector(
  getCalendar,
  ({ multipleDeleteFetching }) => multipleDeleteFetching
);

export const selectCurrentActivityByUserId = createSelector(
  getCalendar,
  ({ userCurrentActivities }) => (userId) => userCurrentActivities[userId]
);

export const selectTimeTableLawsCompliance = createSelector(
  getCalendar,
  ({ lawsCompliance }) => lawsCompliance
);

export const selectTimeTableLawsComplianceFetching = createSelector(
  getCalendar,
  ({ lawsComplianceFetching }) => lawsComplianceFetching
);